import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/style.scss'
import './styles/smooth-scroll.js'
import App from './App'
import { Provider } from 'react-redux'
import { store } from 'store/index'
import "./i18n";
import { AuthProvider } from 'contexts/AuthContext'
import { CartProvider } from 'contexts/CartContext'
import { ThemeProvider } from 'contexts/ThemeContext'
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider>
          <AuthProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AuthProvider>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
